const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Users Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Users', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  return $resource(appConfiguration.apiUrl + '/learn/v3/users/:subresource/:subsubresource', null, {
      get: {params: {subresource: '', subsubresource: ''}, method: 'GET', isArray: false},
      find: {params: {subresource: '', subsubresource: ''}, method: 'GET', isArray: true},
      specialSearch: {params: {subresource: 'special-search', subsubresource: ''}, method: 'POST', isArray: true},
      findFromSet: {params: {subresource: 'from-set', subsubresource: ''}, method: 'POST', isArray: true},
      findExcludingSet: {params: {subresource: 'excluding-set', subsubresource: ''}, method: 'POST', isArray: true},
      create: {params: {subresource: '', subsubresource: ''}, method: 'POST', isArray: false},
      count: {params: {subresource: 'count', subsubresource: ''}, method: 'GET', isArray: false},
      suspended: {params: {subresource: 'suspended', subsubresource: ''}, method: 'GET', isArray: true},
      segmentationCount: {params: {subresource: 'segmentation-count', subsubresource: ''}, method: 'POST', isArray: false},
      segmentationList: {params: {subresource: 'segmentation-list', subsubresource: ''}, method: 'POST', isArray: true},
      update: {params: {subresource: '', subsubresource: ''}, method: 'POST', isArray: false},
      managerSegmentationUpdate: {params: {subresource: 'manager-segmentation', subsubresource: ''}, method: 'POST', isArray: false},
      suspend: {params: {subresource: 'suspend', subsubresource: ''}, method: 'POST', isArray: false},
      unsuspend: {params: {subresource: 'unsuspend', subsubresource: ''}, method: 'POST', isArray: false},
      delete: {params: {subresource: 'remove', subsubresource: ''}, method: 'POST', isArray: false},
      singleresetting: {params: {subresource: '', subsubresource: 'resetting'}, method: 'POST', isArray: false},
      resetting: {params: {subresource: 'resetting', subsubresource: ''}, method: 'POST', isArray: false},
      reinvite: {params: {subresource: 'reinvite', subsubresource: ''}, method: 'POST', isArray: false},
      accept: {params: {subresource: 'accept', subsubresource: ''}, method: 'POST', isArray: false},
      reset: {params: {subresource: 'reset', subsubresource: ''}, method: 'POST', isArray: false},
      seatStatus: {params: {subresource: 'seat-status'}, method: 'GET', isArray: false},
      companySeats: {params: {subresource: 'company-seats'}, method: 'GET', isArray: false}
    });
  }]);


